import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PublicContext from '../PublicContext'
import dayjs from 'dayjs'
import { screenSize } from '../../Common/Common'
import MobileCreateAppointmentPage from './Mobile/MobileCreateAppointmentPage'
import ComputerCreateAppointmentPage from './Computer/ComputerCreateAppointmentPage'
import TabletCreateAppointmentPage from './Tablet/TabletCreateAppointmentPage'
import { post } from '../../Common/api'
import { useNavigate } from 'react-router'

export default function CreateAppointmentPage () {
  const { t } = useTranslation()
  const { box, params, isNow, setSiderTitle, user } = useContext(PublicContext)
  const navigate = useNavigate()
  const date = isNow ? dayjs() : dayjs(params.get('date'))
  const [loading, setLoading] = useState(false)

  const onFinishFailed = () => {
    setLoading(false)
  }

  const onFinish = (values) => {
    setLoading(true)
    const phone = values.phone
    if ((phone.slice(0, 3) === '+06') || (phone.slice(0, 3) === '+07')) {
      values.phone = '+33' + phone.slice(2)
    }
    values = {
      ...values,
      phone: values.phone.slice(1),
      date,
      box_id: box.id,
      is_now: isNow,
      created_by: user?.from || 'web'
    }
    post({
      url: 'public/appointments',
      params: values,
      onSuccess: (json) => {
        if (json.sms_confirmed) {
          navigate(`/appointments/${json.id}`)
        } else {
          navigate(`/box/${box.id}/confirm_appointment/${json.id}`)
        }
      }
    })
    setLoading(false)
  }

  useEffect(() => {
    setSiderTitle(t('Public.CreateAppointmentPage.title'))
  }, [])

  const appointmentForm = {
    Mobile: MobileCreateAppointmentPage,
    Computer: ComputerCreateAppointmentPage,
    Tablet: TabletCreateAppointmentPage
  }

  const ResponsiveForm = appointmentForm[screenSize()]

  return (
    <ResponsiveForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
  )
}
